export default {
  customerAccept: {
    method: 'get',
    url: '/customer/accept',
    headers: {
      tokenInvite: ''
    }
  },
  'get-list': {
    method: 'post',
    url: '/customer/list'
  },
  'customer-add': {
    method: 'post',
    url: '/customer'
  },
  'customer-edit': {
    method: 'put',
    url: '/customer/ID'
  },
  'customer-delete': {
    method: 'delete',
    url: '/customer'
  },
  find: {
    method: 'get',
    url: '/customer/find?key=KEY'
  },
  checkInvitation: {
    method: 'get',
    url: '/customer/check-invitation',
    headers: {
      tokenInvite: ''
    }
  }
}
